import { useGetSafeClientCode } from '@/hooks/router'
import { useNavigate } from '@tanstack/react-router'
import { ChevronRightIcon } from 'lucide-react'

import { MarketSummaryDto } from '@/gen/publicApi'

import { TableCell, TableRow } from '@/components/table'

import { cn } from '@/utils/cn'

interface Props {
    market: MarketSummaryDto
}

export default function InstrumentRow({ market }: Props) {
    const clientCode = useGetSafeClientCode()
    const navigate = useNavigate()

    const onMarketClick = (market_code: string) => {
        navigate({
            to: `/$client_code/markets/$market_code`,
            params: {
                client_code: clientCode,
                market_code,
            },
        })
    }
    return (
        <>
            <TableRow
                key={market.code}
                onClick={() => onMarketClick(market.code)}
                className={cn('cursor-pointer', {
                    'text-destructive': market.rowState === 'Deleted',
                })}
            >
                <TableCell>{market.code}</TableCell>
                <TableCell>{market.marketType}</TableCell>
                <TableCell>{market.name}</TableCell>
                <TableCell>{market.timezone}</TableCell>
                <TableCell>{market.rowState}</TableCell>
                <TableCell className="flex justify-end">
                    <ChevronRightIcon />
                </TableCell>
            </TableRow>
        </>
    )
}
